import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, exhaustMap } from 'rxjs/operators';
import { CategoryService } from '@services/category.service';
import * as PublicCategoriesActions from './public-categories.actions';

@Injectable()
export class PublicCategoriesEffects {
  private readonly actions$ = inject(Actions);
  private readonly categoryService = inject(CategoryService);

  loadPublicCategories$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PublicCategoriesActions.loadPublicCategories),
      exhaustMap(() =>
        this.categoryService.getPublicCategoryList(0, 100).pipe( // Fetch a reasonable number for display
          map(response => PublicCategoriesActions.loadPublicCategoriesSuccess({ response })),
          catchError(error => of(PublicCategoriesActions.loadPublicCategoriesFailure({ error })))
        )
      )
    )
  );
}
